export default __webpack_public_path__ + "2d43ab0bf8256121317d13d6a60aae0f.png";